export const restoreFormVisited = (instance, answers, currentQuestion) => { //available to extend to another question types
    let module = answers.find(answer => answer.module.type === 'form');

    if(module && module?.index > currentQuestion?.index -1) {
        const moduleAnswer = instance.getModuleAnswerByIndex(module.index);
        moduleAnswer.visited = 'returned';
    }

}